<template>
  <div >
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild" :to="resolvePath(onlyOneChild.path==null?'':onlyOneChild.path )">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.iconCls||(item.name&&item.iconCls)" :title="onlyOneChild.name" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path==null?'':item.path )" popper-append-to-body>
      <template slot="title" style="height: 60px;line-height: 60px">
        <item v-if="item" :icon="item.name && item.iconCls" :title="item.name" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path==null?'':child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {

    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {

    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      if(this.basePath !=null && routePath!=null){
        return path.resolve(this.basePath, routePath)
      }else if(routePath!=null){
        return routePath
      }

    }
  }
}
</script>


<style >

.el-submenu>.el-submenu__title i{
  color: #ffffff;
}
/*.sidebar-container .nest-menu .el-submenu>.el-submenu__title i{*/
/*  color: #ffffff;*/
/*}*/
/*.el-submenu__title:hover{*/
/*  background-color: ;*/
/*}*/
 .sidebar-container .nest-menu .el-submenu>.el-submenu__title, #app .sidebar-container .el-submenu .el-menu-item {
  /*margin-left: 30px;*/
   padding-left: 68px !important;
}


 /* .el-menu-item i{
   color: #FFFFFF !important;
 } */
.el-submenu .el-menu-item{
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/SidebarItem.vue